import { ReactElement } from 'react';
import './index.css';
import {
  SideMenuItem,
  SideMenu,
  SideMenuSection,
  SideMenuTitle,
  SideMenuSubTitle,
  SideMenuSelect,
} from './SideMenu';
import TopBar from './TopBar';
import { Section } from './types';

interface Props {
  children: ReactElement | Array<ReactElement | undefined> | undefined;
  sections?: Section[];
  hasPositiveProfit?: boolean;
  noScroll?: boolean;
}

export const Layout = (props: Props) => {
  const { children, hasPositiveProfit } = props;

  return (
    <div className="layout-container">
      <TopBar hasPositiveProfit={hasPositiveProfit} />
      <div className="layout-row">{children}</div>
    </div>
  );
};

const Content = ({ children, noScroll }: Props) => {
  const className = noScroll
    ? 'content-container content-container--no-scroll'
    : 'content-container';
  return <div className={className}>{children}</div>;
};

Layout.Content = Content;
Layout.SideMenu = SideMenu;
Layout.SideMenuSection = SideMenuSection;
Layout.SideMenuTitle = SideMenuTitle;
Layout.SideMenuSubTitle = SideMenuSubTitle;
Layout.SideMenuItem = SideMenuItem;
Layout.SideMenuSelect = SideMenuSelect;

export default Layout;
